/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ku-iq',
  Pagination: {
    items_per_page: '/ rûpel',
    jump_to: 'Biçe',
    jump_to_confirm: 'piştrast bike',
    page: '',
    prev_page: 'Rûpelê Pêş',
    next_page: 'Rûpelê Paş',
    prev_5: '5 Rûpelên Pêş',
    next_5: '5 Rûpelên Paş',
    prev_3: '3 Rûpelên Pêş',
    next_3: '3 Rûpelên Paş'
  },
  DatePicker: {
    lang: {
      placeholder: 'Dîrok hilbijêre',
      rangePlaceholder: ['Dîroka destpêkê', 'Dîroka dawîn'],
      locale: 'ku_IQ',
      today: 'Îro',
      now: 'Niha',
      backToToday: 'Vegere îro',
      ok: 'Temam',
      clear: 'Paqij bike',
      month: 'Meh',
      year: 'Sal',
      timeSelect: 'Demê hilbijêre',
      dateSelect: 'Dîrok hilbijêre',
      monthSelect: 'Meh hilbijêre',
      yearSelect: 'Sal hilbijêre',
      decadeSelect: 'Dehsal hilbijêre',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Meha peş (PageUp))',
      nextMonth: 'Meha paş (PageDown)',
      previousYear: 'Sala peş (Control + şep)',
      nextYear: 'Sala paş (Control + rast)',
      previousDecade: 'Dehsalen peş',
      nextDecade: 'Dehsalen paş',
      previousCentury: 'Sedsalen peş',
      nextCentury: 'Sedsalen paş'
    },
    timePickerLocale: {
      placeholder: 'Demê hilbijêre'
    }
  },
  TimePicker: {
    placeholder: 'Demê hilbijêre'
  },
  Calendar: {
    lang: {
      placeholder: 'Dîrok hilbijêre',
      rangePlaceholder: ['Dîroka destpêkê', 'Dîroka dawîn'],
      locale: 'ku_IQ',
      today: 'Îro',
      now: 'Niha',
      backToToday: 'Vegere îro',
      ok: 'Temam',
      clear: 'Paqij bike',
      month: 'Meh',
      year: 'Sal',
      timeSelect: 'Demê hilbijêre',
      dateSelect: 'Dîrok hilbijêre',
      monthSelect: 'Meh hilbijêre',
      yearSelect: 'Sal hilbijêre',
      decadeSelect: 'Dehsal hilbijêre',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Meha peş (PageUp))',
      nextMonth: 'Meha paş (PageDown)',
      previousYear: 'Sala peş (Control + şep)',
      nextYear: 'Sala paş (Control + rast)',
      previousDecade: 'Dehsalen peş',
      nextDecade: 'Dehsalen paş',
      previousCentury: 'Sedsalen peş',
      nextCentury: 'Sedsalen paş'
    },
    timePickerLocale: {
      placeholder: 'Demê hilbijêre'
    }
  },
  Table: {
    filterTitle: 'Menuê peldanka',
    filterConfirm: 'Temam',
    filterReset: 'Jê bibe',
    selectAll: 'Hemî hilbijêre',
    selectInvert: 'Hilbijartinan veguhere'
  },
  Modal: {
    okText: 'Temam',
    cancelText: 'Betal ke',
    justOkText: 'Temam'
  },
  Popconfirm: {
    okText: 'Temam',
    cancelText: 'Betal ke'
  },
  Transfer: {
    searchPlaceholder: 'Lêgerîn',
    itemUnit: 'tişt',
    itemsUnit: 'tişt'
  },
  Upload: {
    uploading: 'Bardike...',
    removeFile: 'Pelê rabike',
    uploadError: 'Xeta barkirine',
    previewFile: 'Pelê pêşbibîne',
    downloadFile: 'Pelê dakêşin'
  },
  Empty: {
    description: 'Agahî tune'
  }
};
